import styled from "styled-components";

/**
 * Wrapper do Radio
 * Define o layout para alinhar o botão de rádio e o texto associado.
 */
export const StyledRadioWrapper = styled.label`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

/**
 * Botão de Rádio
 * Estiliza o botão de seleção com bordas arredondadas e estados dinâmicos.
 */
export const StyledRadio = styled.input.withConfig({
  shouldForwardProp: (prop) => !["isSelected"].includes(prop),
})`
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  margin-right: ${({ theme }) => theme.spacing(1)};
  height: ${({ theme }) => theme.spacing(3)};
  width: ${({ theme }) => theme.spacing(3)};
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  &:checked::before {
    background-color: ${({ theme }) => theme.colors.aquaBlue};
    height: ${({ theme }) => theme.spacing(1.7)};
    width: ${({ theme }) => theme.spacing(1.7)};
    border-radius: 50%;
    position: absolute;
    content: "";
  }
`;

/**
 * Texto associado ao Radio
 * Estiliza o texto exibido ao lado do botão com ajustes dinâmicos.
 */
export const StyledRadioLabel = styled.span.withConfig({
  shouldForwardProp: (prop) => !["isSelected"].includes(prop),
})<{ isSelected: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.white : theme.colors.white};
`;
